function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@kuaizhan/kui';
import './style.less';

var HeaderMsgDialog = /*#__PURE__*/function (_Component) {
  _inherits(HeaderMsgDialog, _Component);

  var _super = _createSuper(HeaderMsgDialog);

  function HeaderMsgDialog(props) {
    var _this;

    _classCallCheck(this, HeaderMsgDialog);

    _this = _super.call(this, props);
    _this.handleConfirm = _this.handleConfirm.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(HeaderMsgDialog, [{
    key: "handleConfirm",
    value: function handleConfirm() {
      var onConfirm = this.props.onConfirm;
      onConfirm();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          hide = _this$props.hide,
          curMsg = _this$props.curMsg;
      var style = {
        padding: 0
      };
      var contentStyle = {
        width: 720,
        height: 360,
        boxSizing: 'border-box',
        padding: '16px 32px',
        lineHeight: 1.5
      };
      var actions = [/*#__PURE__*/React.createElement(Button, {
        key: "confirm",
        type: "primary",
        onClick: this.handleConfirm
      }, "\u5173\u95ED")];
      return /*#__PURE__*/React.createElement(Dialog, {
        hide: hide,
        title: curMsg.title,
        actions: actions,
        style: style,
        onClose: this.handleConfirm
      }, /*#__PURE__*/React.createElement("div", {
        style: contentStyle // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: curMsg.content
        }
      }));
    }
  }]);

  return HeaderMsgDialog;
}(Component);

HeaderMsgDialog.defaultProps = {
  onConfirm: function onConfirm() {},
  hide: true,
  curMsg: {
    title: '',
    content: ''
  }
};
HeaderMsgDialog.propTypes = {
  onConfirm: PropTypes.func,
  hide: PropTypes.bool,
  curMsg: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string
  })
};
export default HeaderMsgDialog;